/* eslint-disable react/prop-types */
import classes from "./composed-view-nine.module.scss";
import Label from "@/components-library/widgets/label";
import Flex from "@/components-library/layout/flex";
import classNames from "classnames";
import GridList from "@/components-library/widgets/grid-list";
import CardViewListStepThreee from "@/composed-views/card-view-list-step-three";
function ComposedViewNine({ header, title, content, steps, className }) {
  var item = <CardViewListStepThreee />;

  return (
    <Flex
      align="center"
      direction="column"
      justify="flex-start"
      className={classNames(classes.container, className)}
    >
      {header && (
        <Label
          weight="bold"
          tag="h5"
          color="primary"
          align="start"
          className={classes.header}
        >
          {header}
        </Label>
      )}

      {title && (
        <Label
          weight="bold"
          tag="h2"
          color="secondary"
          align="start"
          className={classes.title}
        >
          {title}
        </Label>
      )}
      {content && (
        <Label align="start" size="md" color="secondary">
          {content}
        </Label>
      )}
      <GridList columns={3} items={steps} itemComponent={item} />
    </Flex>
  );
}

export default ComposedViewNine;
